import { Box, Grid, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import RegisterHeader from '../../../../components/register-header/RegisterHeader'
import CustomModal from '../../../../components/modal/CustomModal'
import { AppUtils } from '../../../../utils/appUtils'
import { ERROR, ID, REQUIRED_FIELD, ROW_PER_PAGE, SOMETHING_WENT_WRONG, SUCCESS } from '../../../../utils/constants'
import AHMIS, { API_URL } from '../../../../api/api'
import AddAlertMessage from '../../../../components/alert/Alert'
import { useForm } from 'react-hook-form'
import NepaliCalender from '../../../../components/nepali-calender'
import { INVALID_BLOOD_PRESSURE_MESSAGE } from '../../../../utils/constants/forms'
import DeleteRegisterRecordConformation from '../../../../components/delete-register-record-conformation/DeleteRegisterRecordConformation'
import StanpaiAamaThathaShishuSewaVivaran from '../../../users/components/register/stanpai-aama-tatha-shishu-sewa-register/helper/StanpaiAamaThathaShishuSewaVivaran'
import { useSelector } from 'react-redux'

const StanpaiAamaThaShishuVivaranForm = () => {
  const [modalTitle, setModalTitle] = useState("स्तनपायी आमा तथा शिशु सेवा रजिष्टर नयाँ रेकर्ड थप्नुहोस्");
  const [showStanpaiAamaThaShishuVivaranModal, setShowStanpaiAamaThaShishuVivaranModal] = useState(false);
  const [modalDefaultValues, setModalDefaultValues] = useState();
  const [stanpaiAamaThaShishuVivaranSewaBibaranTableData, setStanpaiAamaThaShishuVivaranSewaBibaranTableData] = useState([]);
  const [getTableData, setGetTableData] = useState(false);
  const { register, handleSubmit, setValue, formState: { errors }, reset, watch } = useForm();
  const [showStanpaiAamaThaShishuVivaranDeleteModal, setShowStanpaiAamaThaShishuVivaranDeleteModal] = useState(false);
  const [page, setPage] = useState(0);
  const [totalSize, setTotalSize] = useState(0);
  const [stanpaiAamaThaShishuVivaranDeleteId, setStanpaiAamaThaShishuVivaranDeleteId] = useState(null);
  const stanpaiAamaThaShishuVivaranRegisterId = AppUtils.getUrlParam(ID);
  const { fromDate, toDate, searchParams } = useSelector((state) => state.dateReducer);

  useEffect(() => {
    showStanpaiAamaThaShishuVivaranModal && reset();
  }, [reset, showStanpaiAamaThaShishuVivaranModal]);

  const openStanpaiAamaThaShishuVivaranModal = () => {
    setShowStanpaiAamaThaShishuVivaranModal(true);
  };

  const closeStanpaiAamaThaShishuVivaranModal = () => {
    setShowStanpaiAamaThaShishuVivaranModal(false);
    setModalDefaultValues();
    reset();
  };

  useEffect(() => {
    register("dartaaMiti", { required: true });
  }, [register]);

  const handleDateChange = (name, dateInMilli) => {
    setValue(name, dateInMilli);
  };


  const submitStanpaiAamaThaShishuVivaranRegister = (data) => {
    if (modalDefaultValues?.id) {
      data.id = modalDefaultValues.id;
    }
    const url = `${API_URL.stanpaiAamaThaShishuVivaranService}?stanpaiAamaThaShishuVivaranServiceRegistrationId=${stanpaiAamaThaShishuVivaranRegisterId}`;
    AHMIS.post(url, data)
      .then(response => {
        if (response.data.type === SUCCESS) {
          closeStanpaiAamaThaShishuVivaranModal();
          setGetTableData(true);
        }
        AddAlertMessage({ type: response.data.type, message: response.data.message });
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  useEffect(() => {
    if (fromDate && toDate) {
      getStanpaiAamaThaShishuVivaranSewaBibaranData(fromDate, toDate, searchParams)
    }
  }, [fromDate, toDate, searchParams, getTableData])

  const getStanpaiAamaThaShishuVivaranSewaBibaranData = (fromDate, toDate, searchParams, healthClientId, pageFromParam) => {
    let url = `${API_URL.stanpaiAamaThaShishuVivaranService}/fromDateRangeAndPage?fromDate=${fromDate}&toDate=${toDate}&pageNumber=${pageFromParam || (Number(page) + 1)}&rowSize=${ROW_PER_PAGE}&stanpaiAamaThaShishuVivaranServiceRegistrationId=${stanpaiAamaThaShishuVivaranRegisterId}`;
    if (healthClientId) {
      url = url + "&healthClientId=" + healthClientId;
    }
    if (searchParams) {
      url = url + "&searchParam=" + searchParams;
    }
    AHMIS.get(url)
      .then(response => {
        let jsondata = response.data;
        setStanpaiAamaThaShishuVivaranSewaBibaranTableData(jsondata?.data?.objectList || []);
        setGetTableData(false);
        setTotalSize(jsondata?.data?.size)
      })
      .catch(error => {
        AddAlertMessage({ type: "error", message: SOMETHING_WENT_WRONG });
      });
  }

  const stanpaiAamaThaShishuVivaranSewaBibaranEdit = (id) => {
    AHMIS.get(API_URL.stanpaiAamaThaShishuVivaranService + "/" + id)
      .then(response => {
        console.log(response)
        setModalDefaultValues(response.data?.data);
        setShowStanpaiAamaThaShishuVivaranModal(true);
      }).catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      })
  }

  const closeStanpaiAamaThaShishuVivaranDeleteModal = () => {
    setShowStanpaiAamaThaShishuVivaranDeleteModal(false);
    setStanpaiAamaThaShishuVivaranDeleteId(null);
  }

  const onDeleteStanpaiAamaThaShishuVivaranRow = (id) => {
    setShowStanpaiAamaThaShishuVivaranDeleteModal(true);
    setStanpaiAamaThaShishuVivaranDeleteId(id);
  }

  const deleteStanpaiAamaThaShishuVivaranSewaBibaranRow = (data) => {
    AHMIS.delete(API_URL.stanpaiAamaThaShishuVivaranService + "/" + stanpaiAamaThaShishuVivaranDeleteId + "?deletedReason=" + data.deletedReason)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setShowStanpaiAamaThaShishuVivaranDeleteModal(false);
          setStanpaiAamaThaShishuVivaranDeleteId(null);
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
          setGetTableData(true);
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(error => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  }

  const onHeaderParamChange = (fromDate, toDate, searchParam, healthClientId) => {
    setPage(0)
    getStanpaiAamaThaShishuVivaranSewaBibaranData(fromDate, toDate, searchParam, healthClientId, 1);
  }

  const handleChangePage = (newPage) => {
    setPage(newPage);
    setGetTableData(true);
  };
  return (
    <>
      <Box marginTop={2}>
        <RegisterHeader
          registerTitle="सेवा विवरण"
          handleModalOpen={openStanpaiAamaThaShishuVivaranModal}
          getRegisterData={getStanpaiAamaThaShishuVivaranSewaBibaranData}
          onHeaderParamChange={onHeaderParamChange}
          getTableData={getTableData}
          fromDateDefaultFormat
          lazyLoading
          showSearchField
        />
      </Box>
      <CustomModal
        title={modalTitle}
        showModal={showStanpaiAamaThaShishuVivaranModal}
        onModalSubmit={handleSubmit(submitStanpaiAamaThaShishuVivaranRegister)}
        onModalClose={closeStanpaiAamaThaShishuVivaranModal}
        maxWidth="lg"
        fullScreen
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={3}>
            <NepaliCalender
              id="dartaa-miti"
              label="दर्ता मिति"
              name="dartaaMiti"
              defaultDate={modalDefaultValues?.dartaaMiti}
              onChange={handleDateChange}
            />
            {errors?.dartaaMiti && errors.dartaaMiti?.type === "required" && <span className="error-message">{REQUIRED_FIELD}</span>}
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="सुत्केरी अवधि"
              size="small"
              variant="outlined"
              name="sutkeriDuration"
              autoComplete="true"
              fullWidth
              defaultValue={modalDefaultValues?.sutkeriDuration}
              {...register("sutkeriDuration")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="समस्या (भएमा मात्र)"
              size="small"
              variant="outlined"
              name="problem"
              autoComplete="true"
              fullWidth
              defaultValue={modalDefaultValues?.problem}
              {...register("problem")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="बितरित औषधि"
              size="small"
              variant="outlined"
              name="distributedMedicine"
              autoComplete="true"
              fullWidth
              defaultValue={modalDefaultValues?.distributedMedicine}
              {...register("distributedMedicine")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="फाईल संख्या"
              size="small"
              variant="outlined"
              name="fileNumber"
              type="number"
              autoComplete="true"
              fullWidth
              defaultValue={modalDefaultValues?.fileNumber}
              {...register("fileNumber")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="स्तन्यको अवस्था"
              size="small"
              variant="outlined"
              name="breastfeedingStatus"
              autoComplete="true"
              fullWidth
              defaultValue={modalDefaultValues?.breastfeedingStatus}
              {...register("breastfeedingStatus")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="परिक्षण/सल्लाह"
              size="small"
              variant="outlined"
              name="examinationAdvice"
              autoComplete="true"
              fullWidth
              defaultValue={modalDefaultValues?.examinationAdvice}
              {...register("examinationAdvice")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="कैफियत"
              size="small"
              variant="outlined"
              name="remarks"
              autoComplete="true"
              fullWidth
              defaultValue={modalDefaultValues?.remarks}
              {...register("remarks")}
            />
          </Grid>
        </Grid>
      </CustomModal>
      <DeleteRegisterRecordConformation
        showDeleteModal={showStanpaiAamaThaShishuVivaranDeleteModal}
        closeDeleteModel={closeStanpaiAamaThaShishuVivaranDeleteModal}
        deleteRecord={deleteStanpaiAamaThaShishuVivaranSewaBibaranRow}
      />
      <StanpaiAamaThathaShishuSewaVivaran
        onEditRow={stanpaiAamaThaShishuVivaranSewaBibaranEdit}
        tableData={stanpaiAamaThaShishuVivaranSewaBibaranTableData}
        deleteRow={onDeleteStanpaiAamaThaShishuVivaranRow}
        page={page}
        handleChangePage={handleChangePage}
        totalSize={totalSize}
        getTableData={(value) => setGetTableData(value)}
      />
    </>
  )
}

export default StanpaiAamaThaShishuVivaranForm
